import { Container } from "react-bootstrap";
import { PrivacyData } from "./privacy-data";
import "./privacy.scss";

export const Privacy = () => {
  return (
    <section>
      <Container className="px-3">
        <div className="privacy-content mt-5">
        <span className=" fw-bold ">[Last Updated 12th December 2024]</span>
          <p className="fs-2 fw-bold  privacy-title">Privacy Policy for PAMO</p>
          <p className="privacy-description fs-6 ">
          Pamo Services Ltd (Pamo, "us", "we", or "our") operates the Pamo App (“App”, "Platform"), an e-commerce platform that connects buyers to Merchants in different locations. We acknowledge your right to the privacy of your Personal Information. This Privacy Policy (the "Policy") informs you of our policies regarding the collection, use, storage, and disclosure of Personal Information we receive from you and visitors of the Platform.
          We use your Personal Information only to provide our services and improve the Platform. By using the Platform, you agree to the collection and use of information in accordance with this Policy as revised from time to time. 
          </p>
        </div>

        <div className="mb-5">
          {PrivacyData.map((data, key) => (
            <ul key={key}>
              <div className="fs-5 fw-bold mt-5 privacy-items">
                {data.listName}
              </div>
              {data.list.map((data, key) => (
                <li className="my-2 privacy-items">{data.item}</li>
              ))}
            </ul>
          ))}
        </div>
      </Container>
    </section>
  );
};
